import { XIconSmall } from '../../../../icon/icons-small/x-small';
import { NakedButton } from '../../../../naked/naked-button.component';
import { styles } from '../../../../styles';
import { Text } from '../../../text/text.component';
import { MultiselectSelectionStyles } from './multiselect-selection.styles';

type Props = {
  children: React.ReactNode;
  onRemove: () => void;
  selectionCount: number;
};

export const MultiselectSelection = ({ children, onRemove, selectionCount }: Props) => {
  const themedText = MultiselectSelectionStyles.textStyles({
    selectionCount,
  });
  const themedButton = MultiselectSelectionStyles.buttonStyles;

  return (
    <Text size='medium' color='light' className={themedText}>
      <span css={styles.truncate}>{children}</span>
      <NakedButton className={themedButton} onClick={onRemove} aria-label='Remove option' type='button'>
        <XIconSmall />
      </NakedButton>
    </Text>
  );
};
